<template>
  <div class="fullPageShimmer" v-if="homeShimmer">
    <div class="pt16">
      <div class="plr16 d-flex justify-content-between">
        <div
          class="hide-shimmer-text shimmer-container br24 rounded width50"
          :style="{ height: '30px' }"
        >
          random
        </div>
        <div
          class="hide-shimmer-text shimmer-container rounder-circle circle-icon"
        ></div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container width100 mt8"
          :style="{ background: '#F4F4F4', height: '20px' }"
        >
          random
        </div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container width60 mt24"
          :style="{ height: '20px' }"
        >
          random
        </div>
      </div>
      <div class="plr16 mt24 d-flex flex-wrap-shimmer">
        <div
          v-for="i in length"
          :key="i"
          class="cursor-pointer align-items-center"
        >
          <div
            class="grid-shimmer shimmer-container rounded hide-shimmer-text br16"
          >
            image
          </div>
        </div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container rounded br8 width100 mt20"
          :style="{ height: '300px' }"
        >
          random
        </div>
      </div>
      <div class="plr16">
        <div
          class="hide-shimmer-text shimmer-container rounded br8 width100 mt20"
          :style="{ height: '200px' }"
        >
          random
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomePageShimmer",
  data() {
    return {
      length: 9,
    };
  },
  computed: {
    homeShimmer() {
      return this.$store.state.ProductItems.homeShimmer;
    },
  },
};
</script>
